import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import { Grid, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import React from "react";

import TextField from "@mui/material/TextField";
import { getAllWorkLocation } from "@/fetch/fetchWork";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

import _ from "lodash";
export default function LocationDialog(props) {
  const {
    onCancel,
    open,
    onSubmit,
    submitMessage,
    cancelMessage,
    title,
    selectedShop,
    currentShop,
    handleOnShopChange,
    submitButtonColor = "primary",
  } = props;
  const [options, setOptions] = React.useState([]);
  const fetch = async () => {
    const workLocarions = await getAllWorkLocation();
    const formattedOptions = _.map(workLocarions.data, (workLocarion) => {
      return {
        label: `${workLocarion.work_name} (${workLocarion.work_shortcode})`,
        value: String(workLocarion.id),
        category: "店鋪",
      };
    });
    setOptions([...formattedOptions]);
  };
  React.useEffect(() => {
    fetch();
  }, []);
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <DialogContentText>
          <Box
            component="form"
            noValidate
            sx={{
              display: "grid",
            }}
          >
            <FormControl fullWidth>
              <TextField
                required
                disabled
                id="combo-box-demo"
                value={currentShop}
                options={options}
                groupBy={(option) => option.category}
                label="店鋪"
              />
            </FormControl>
            <FormControl fullWidth>
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center"
                sx={{ minHeight: "10vh" }}
              >
                <ArrowDownwardIcon />
              </Grid>
            </FormControl>

            <FormControl fullWidth>
              <Autocomplete
                required
                id="combo-box-demo"
                options={options}
                groupBy={(option) => option.category}
                value={options.find((option) => option.value === selectedShop)}
                label="店鋪"
                onChange={(event, newValue) => {
                  handleOnShopChange(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="店鋪" />}
              />
            </FormControl>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{cancelMessage}</Button>
        <Button
          onClick={onSubmit}
          color={submitButtonColor}
          disabled={!selectedShop || selectedShop === currentShop}
          type="submit"
        >
          {submitMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
